function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.0938 7.875C14.0938 7.49414 14.3867 7.17188 14.7969 7.17188C15.1777 7.17188 15.5 7.49414 15.5 7.875C15.5 12.0352 12.1309 15.375 8 15.375C3.83984 15.375 0.5 12.0352 0.5 7.875C0.5 7.49414 0.792969 7.17188 1.20312 7.17188C1.58398 7.17188 1.90625 7.49414 1.90625 7.875C1.90625 11.2441 4.63086 13.9688 8 13.9688C11.3398 13.9688 14.0938 11.2441 14.0938 7.875ZM7.47266 0.609375C7.58984 0.462891 7.79492 0.375 7.9707 0.375C8.17578 0.375 8.38086 0.462891 8.49805 0.609375L11.5449 3.89062C11.8086 4.18359 11.8086 4.62305 11.5156 4.88672C11.2227 5.15039 10.7832 5.12109 10.5195 4.85742L8.70312 2.89453V9.98438C8.70312 10.3945 8.38086 10.6875 7.9707 10.6875C7.58984 10.6875 7.26758 10.3945 7.26758 9.98438V2.89453L5.45117 4.85742C5.1875 5.12109 4.74805 5.15039 4.45508 4.88672C4.16211 4.62305 4.16211 4.18359 4.42578 3.89062L7.47266 0.609375Z",
  fill: "#767B87"
});

const SvgUpgradeToLatest = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgUpgradeToLatest, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upgrade_to_latest.1325b47f.svg";
export { ForwardRef as ReactComponent };